module.exports = __webpack_public_path__ + "img/end-call.5a93072c.svg";